/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Portal_Invite_SentInputs */

const cs_client_portal_invite_sent = /** @type {(inputs: Client_Portal_Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozvánka do portálu vytvořena.`)
};

const en_client_portal_invite_sent = /** @type {(inputs: Client_Portal_Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal invite created.`)
};

/**
* | output |
* | --- |
* | "Portal invite created." |
*
* @param {Client_Portal_Invite_SentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_portal_invite_sent = /** @type {((inputs?: Client_Portal_Invite_SentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Portal_Invite_SentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_portal_invite_sent(inputs)
	return cs_client_portal_invite_sent(inputs)
});